module.exports = __webpack_public_path__ + "static/0054-b083a26c9f55e5d6dc3fbfc50c73cd61.png";